const c_step  = 0.01667; // 1/60 s

export default
({namespaced: true,

  state: 
  { timestampStart: null,
    timestampLast:  null,
    timestampStop:  performance.now(),
    fpsSet:         null, // set when the loop is started
    deltaSet:       null, // set when the loop is started
    fps:            0,
    fpsMin:         0,
    fpsMax:         0,
    delta:          null, // != null, iff the loop is running
    nrOfSteps:      null, // != null, iff the loop is running
  },

  actions:
  { start({ state, dispatch }, fps_set = 60) // fps_set: fps to be achieved
    { if (state.delta != null){ return; } // the loop is already running

      state.fpsSet   = fps_set;
      state.deltaSet = 1/fps_set;

      state.timestampStart = performance.now();
      state.timestampLast  = state.timestampStart - 1000/fps_set;
      state.timestampStop  = null;

      state.nrOfStep = 0;
      
      state.fps    = fps_set;
      state.fpsMin = fps_set;
      state.fpsMax = fps_set;

      window.requestAnimationFrame((timestamp) => dispatch('_step', { timestamp }))
    },

    stop({ state })
    { if (state.delta == null){ return; } // the loop is not running

      state.timestampStop = performance.now();
      state.delta         = null;
      state.nrOfSteps     = null; // ??
    },

    _step({ state, dispatch }, { timestamp } )
    { const
        c_delta = (timestamp - state.timestampLast)/1000;

      state.nrOfSteps++;

      state.fps = 1/c_delta;
      if (state.nrOfSteps > 10)
      { state.fpsMin = state.fps < state.fpsMin ? state.fps : state.fpsMin;
        state.fpsMax = state.fps > state.fpsMax ? state.fps : state.fpsMax;
        state.delta  = c_delta;
        
        dispatch('step', { timestamp })
      }

      state.timestampLast = timestamp;
      
      if (state.timestampStop == null)
      { if (state.deltaSet === 60)
        { window.requestAnimationFrame((timestamp) => dispatch('_step', { timestamp })) }
        else
        { setTimeout
          (() =>
           window.requestAnimationFrame((timestamp) => dispatch('_step', { timestamp })), 
           state.deltaSet*950 // 1000 ms = 1 s; 5 % buffer is given
          )
        }
      }
    },

    step(){}, // may be listend to by this.$store.subscribeAction (see comment below)
  }
})

/*
  mounted()
  { this._unsubscribe =
    this.$store.subscribeAction
    ( ({type}, {delta}) =>                // ({type, payload}, {delta})
      { if (type === 'gameloop/step') 
        { this.update(delta) }            // payload.timestamp exists
      }
    )
  },

  unmounted()
  { this._unsubscribe();
    this._unsubscribe = null;
  },
  */